/**
 * 아이디·비밀번호 찾기 (/m/findmem — 장비불러 앱, 리뉴얼 화면 signup/findmemV2)
 * 이름·번호로 아이디 찾기, 본인인증(이니시스·SMS) 뒤 비밀번호 재설정
 * ($j.Pages.Mobile.FindMemV2 / body data-page-name="FindMemV2")
 *
 * window.inicisCallback — 이니시스 인증 창이 결과를 돌려주는 창 사이 약속이라 window 에 둔다.
 */
export default class FindMemV2 {
    initialize() {
        // 본인인증 생략(개발 서버) — F/Inicis 가 G5['inicisByPass'] 를 본다
        G5['inicisByPass'] = JSON.parse(document.getElementById('page-data')?.textContent || '{}').inicisByPass;

        // 본인인증을 마쳤는지 — 마친 뒤에는 탭을 오가도 결과·입력폼이 그대로 남는다
        let passAuth = false;
        let idResult = null;   // {mem_id, sns_type, type:'find'|'auth'}
        let busy = false;

        const SNS = {
            K: { key: 'kakao', name: '카카오', img: '/img/mercury/ka_logo.png' },
            N: { key: 'naver', name: '네이버', img: '/img/mercury/na_logo.png' },
        };

        $(function () {
            initTabs();
            initFindId();
            initInicis();
            initSms();
            initPasswordReset();
        });

        /* ───────────── 탭 ───────────── */

        // 핸들러는 한 번만 건다 — 예전 코드는 화면을 전환할 때마다 다시 걸어서
        // 탭을 오갈수록 클릭 한 번에 핸들러가 여러 벌 돌았다
        function initTabs() {
            $('.fm-tabs').on('click', '.fm-tab', function () {
                showTab(this.id === 'tab-pw' ? 'pw' : 'id');
            });
        }

        function showTab(which) {
            const isPw = which === 'pw';
            $('#tab-id').attr('aria-selected', String(!isPw));
            $('#tab-pw').attr('aria-selected', String(isPw));
            $('#panel-id').prop('hidden', isPw);
            $('#panel-pw').prop('hidden', !isPw);
            renderIdPanel();
            renderPwPanel();
        }

        /* ───────────── 아이디 찾기 ───────────── */

        function initFindId() {
            $j.Common.Form.registerPhoneHandler('fm_phone');   // 치는 대로 대시를 넣는다
            $('#fm-find-id').on('click', findId);
            $('#fm_name, #fm_phone').on('input', function () { setErr(this.id, ''); });
        }

        function findId() {
            const name = $('#fm_name').val().trim();
            const phone = $j.Common.Util.phoneNumber($('#fm_phone').val());

            // 예전에는 빈칸으로 눌러도 서버까지 갔다 — 빈 이름이 누군가와 맞을 이유가 없다
            setErr('fm_name', name ? '' : '이름을 입력해 주세요.');
            setErr('fm_phone', !phone ? '휴대폰 번호를 입력해 주세요.'
                : phone.replace(/[^0-9]/g, '').length < 10 ? '휴대폰 번호를 끝까지 입력해 주세요.' : '');
            if (!name || $('#err-fm_phone').text()) return;

            if (busy) return;
            busy = true;

            $.ajax({ url: '/m/ajax/member/find/id', method: 'get', data: { real_name: name, mem_phone: phone } })
                .done(function (res) {
                    if (!res || !res.mem_id) {
                        $j.Common.Util.swalert('입력하신 정보와 일치하는 아이디가 없어요.\n본인인증으로 찾아보시겠어요?');
                        return;
                    }
                    idResult = { mem_id: res.mem_id, sns_type: res.sns_type, type: 'find' };
                    renderIdPanel();
                })
                .fail(function () {
                    $j.Common.Util.swalert('아이디를 찾는 중 오류가 발생했어요.\n잠시 후 다시 시도해 주세요.');
                })
                .always(function () { busy = false; });
        }

        /** 아이디 탭 다시 그리기 — 결과가 있으면 결과를, 없으면 입력폼을 보여준다 */
        function renderIdPanel() {
            $('#fm-id-forms').prop('hidden', !!idResult);
            $('#fm-id-result').prop('hidden', !idResult);
            if (!idResult) return;

            const isSocial = $j.Common.Util.isSocialId(idResult.mem_id);
            const full = idResult.type === 'auth';

            // 본인인증으로 왔으면 전체, 회원정보로 찾았으면 뒤 3자리를 가린다
            $('#fm-found-id').text(full ? idResult.mem_id : idResult.mem_id.slice(0, -3) + '***');
            $('#fm-found-note').text(full ? '' : '뒤 3자리는 가렸어요. 본인인증을 하면 전체를 볼 수 있어요.');

            const acts = [];
            const sns = SNS[idResult.sns_type];
            if (sns) {
                acts.push(`<a class="fm-go fm-go--${sns.key}" href="#" data-sns="${sns.key}">
                               <img src="${sns.img}" alt="" aria-hidden="true">${sns.name}로 로그인</a>`);
            }
            if (!isSocial) {
                // 소셜 전용 아이디는 이 앱에서 비밀번호를 쓰지 않는다 — 재설정 자리를 만들지 않는다
                acts.push(full
                    ? '<button type="button" class="sg-cta" data-act="reset-pw">비밀번호 재설정</button>'
                    : '<button type="button" class="sg-cta" data-inicis="id">전체 아이디 확인</button>');
                acts.push('<button type="button" class="fm-sub" data-act="go-login">로그인하러 가기</button>');
            } else {
                acts.push('<button type="button" class="fm-sub" data-act="go-login">로그인하러 가기</button>');
            }
            $('#fm-id-acts').html(acts.join(''));
        }

        $(document).on('click', '[data-act="go-login"]', function () { location.replace('/m/login'); });
        $(document).on('click', '[data-sns]', function (e) { e.preventDefault(); $j.F.Social.login(this.dataset.sns); });
        $(document).on('click', '[data-act="reset-pw"]', function () { showTab('pw'); });

        /* ───────────── 본인인증(이니시스) ───────────── */

        function initInicis() {
            $(document).on('click', '[data-inicis]', function () {
                const type = this.dataset.inicis;   // id | pass
                $j.F.Inicis.auth({
                    successUrl: $j.Common.Util.getHost() + '/m/plugin/inicis/callback/' + type,
                    failUrl: $j.Common.Util.getHost() + '/m/plugin/inicis/callback/' + type,
                    type,
                });
            });
        }

        // 인증 팝업이 부모창의 전역 inicisCallback 을 부른다
        window.inicisCallback = function (data) {
            if (!data || !data.result) {
                $j.Common.Util.swalert((data && data.message) || '본인인증을 완료하지 못했어요. 다시 시도해 주세요.');
                return;
            }
            if (data.type === 'id') {
                idResult = { mem_id: data.info.mem_id, sns_type: data.info.sns_type, type: 'auth' };
                passAuth = true;   // 같은 인증으로 비밀번호도 새로 정할 수 있다
                showTab('id');
            } else if (data.type === 'pass') {
                passAuth = true;
                showTab('pw');
            }
        };

        /* ───────────── 전화번호로 찾기(SMS) ───────────── */

        function initSms() {
            $(document).on('click', '[data-sms]', function (e) {
                e.preventDefault();
                $j.F.SmsAuth.start('pass');
            });

            $j.Common.EventBus.on(G5['NS'], 'sms:auth', function (e, data) {
                if (!data || !data.result) {
                    $j.Common.Util.swalert((data && data.message) || '인증에 실패했어요.');
                    return;
                }
                $j.F.SmsAuth.close();
                // 서버가 임시 비밀번호를 만들어 알려준다 — 그대로 두면 4자리로 계속 쓰게 되므로
                // 로그인 화면으로 보내면서 바꾸라고 알린다
                $j.Common.Util.swalert(data.message + '\n\n로그인한 뒤 [내정보 > 비밀번호 변경]에서 바꿔 주세요.',
                    function () { location.replace('/m/login'); });
            });
        }

        /* ───────────── 새 비밀번호 ───────────── */

        function initPasswordReset() {
            $('.sg-eye').on('click', function () {
                const $inp = $(this).siblings('input');
                const show = $inp.attr('type') === 'password';
                $inp.attr('type', show ? 'text' : 'password');
                $(this).attr({ 'aria-pressed': String(show), 'aria-label': show ? '비밀번호 숨기기' : '비밀번호 보기' });
            });

            $('#fm_pwd, #fm_pwd2').on('input', function () {
                renderRules();
                const pw = $('#fm_pwd').val(), pw2 = $('#fm_pwd2').val();
                setErr('fm_pwd2', pw2 && pw !== pw2 ? '비밀번호가 일치하지 않아요.' : '');
                $('#fm-pw-save').prop('disabled', !($j.Core.Config.PASSWORD_RE.test(pw) && pw === pw2));
            });

            $('#fm-pw-save').on('click', savePassword);
        }

        function renderRules() {
            const v = $('#fm_pwd').val() || '';
            const ok = { alpha: /[a-z]/i.test(v), digit: /\d/.test(v), length: v.length >= 8 };
            $('#fm-pw-rules .sg-rule').each(function () {
                this.classList.toggle('is-ok', !!ok[this.dataset.rule]);
            });
        }

        function renderPwPanel() {
            $('#fm-pw-auth').prop('hidden', passAuth);
            $('#fm-pw-reset').prop('hidden', !passAuth);
        }

        function savePassword() {
            if (busy || $('#fm-pw-save').prop('disabled')) return;
            busy = true;
            $('#fm-pw-save').addClass('is-loading');

            $.ajax({
                url: '/m/ajax/member/password/reset-after-inicis',
                method: 'POST',
                data: { mem_pwd: $('#fm_pwd').val() },
            })
                .done(async function (res) {
                    if (!res || !res.success) { $j.Common.Util.swalert((res && res.message) || '비밀번호를 바꾸지 못했어요.'); return; }
                    // 반드시 답해야 하는 창 — ✕·백드롭·ESC 를 막는다
                    await $j.Ui.Dialog.alert('비밀번호가 변경되었습니다.', { tone: 'success', dismissible: false });
                    location.replace('/m/login');
                })
                .fail(function () {
                    $j.Common.Util.swalert('비밀번호 변경 중 오류가 발생했어요.\n잠시 후 다시 시도해 주세요.');
                })
                .always(function () {
                    busy = false;
                    $('#fm-pw-save').removeClass('is-loading');
                });
        }

        /* ───────────── 공통 ───────────── */

        function setErr(id, msg) {
            $('#err-' + id).text(msg);
            $('#' + id).toggleClass('is-error', !!msg);
        }
    }
}
